type FeatureTest = {
  name: string;
};

export type FeatureTestVariant = {
  name: string;
};

export type FeatureTestUserVariant = {
  featureTest: FeatureTest;
  featureTestVariant: FeatureTestVariant;
};

type JSONFeatureTest = {
  name: string;
};

type JSONFeatureTestVariant = {
  name: string;
};

export type JSONFeatureTestUserVariant = {
  feature_test: JSONFeatureTest;
  feature_test_variant: JSONFeatureTestVariant;
  id: number;
  object_created: string;
  object_updated: string;
};

export const featureTestUserVariantFromJSON = (
  variant: JSONFeatureTestUserVariant,
): FeatureTestUserVariant => ({
  featureTest: {
    name: variant.feature_test.name,
  },
  featureTestVariant: {
    name: variant.feature_test_variant.name,
  },
});
